export const testIds = {
  brandLogo: "brand-logo",
  navCatalog: "nav-catalog",
  navQuote: "nav-quote",
  navAdmin: "nav-admin",
  quoteCounter: "quote-counter",

  catalogSearchInput: "catalog-search-input",
  categoryFilterAll: "category-filter-tutti",
  categoryFilterAudio: "category-filter-audio",
  categoryFilterLuci: "category-filter-luci",
  categoryFilterVideo: "category-filter-video",
  categoryFilterDj: "category-filter-dj",
  categoryFilterStrutture: "category-filter-strutture",
  catalogDateStart: "catalog-date-start",
  catalogDateEnd: "catalog-date-end",
  catalogSampleBtn: "catalog-sample-pdf-btn",
  itemCard: (id) => `item-card-${id}`,
  addToQuoteBtn: (id) => `add-to-quote-btn-${id}`,
  removeFromQuoteBtn: (id) => `remove-from-quote-btn-${id}`,
  itemQtyMinus: (id) => `item-qty-minus-${id}`,
  itemQtyPlus: (id) => `item-qty-plus-${id}`,
  itemAvailability: (id) => `item-availability-${id}`,

  quoteStartDate: "quote-start-date",
  quoteEndDate: "quote-end-date",
  quoteDaysBadge: "quote-days-badge",
  quoteDiscountBadge: "quote-discount-badge",
  quoteCustomerName: "quote-customer-name",
  quoteCustomerEmail: "quote-customer-email",
  quoteCustomerPhone: "quote-customer-phone",
  quoteNotes: "quote-notes",
  quoteSubmit: "quote-submit-btn",
  quoteClear: "quote-clear-btn",
  quoteWhatsapp: "quote-whatsapp-btn",
  quoteCopy: "quote-copy-btn",
  quoteTotal: "quote-total",
  quotePdfBtn: "quote-pdf-btn",

  adminLoginPassword: "admin-login-password",
  adminLoginBtn: "admin-login-btn",
  adminLogoutBtn: "admin-logout-btn",
  adminAddItemBtn: "admin-add-item-btn",
  adminItemForm: "admin-item-form",
  adminItemName: "admin-item-name",
  adminItemCategory: "admin-item-category",
  adminItemPrice: "admin-item-price",
  adminItemQty: "admin-item-qty",
  adminItemDesc: "admin-item-desc",
  adminItemImage: "admin-item-image",
  adminItemSave: "admin-item-save-btn",
  adminItemCancel: "admin-item-cancel-btn",
  adminEditItem: (id) => `admin-edit-item-${id}`,
  adminDeleteItem: (id) => `admin-delete-item-${id}`,
  adminTabItems: "admin-tab-items",
  adminTabQuotes: "admin-tab-quotes",
  adminTabCalendar: "admin-tab-calendar",
  adminTabBlocks: "admin-tab-blocks",
  adminTabSettings: "admin-tab-settings",
  adminTabCollaborators: "admin-tab-collaborators",
  adminTabStats: "admin-tab-stats",
  adminTabPending: "admin-tab-pending",
  adminTabReviews: "admin-tab-reviews",
  adminAddReviewBtn: "admin-add-review-btn",
  adminReviewAuthor: "admin-review-author",
  adminReviewText: "admin-review-text",
  adminReviewSave: "admin-review-save-btn",
  navGuide: "nav-guide",
  adminStatsMonth: "admin-stats-month",
  adminCommissionInput: "admin-commission-input",
  adminCommissionSave: "admin-commission-save-btn",
  adminInternalPdf: (id) => `admin-quote-internal-pdf-${id}`,
  adminPendingApprove: (id) => `admin-pending-approve-${id}`,
  adminPendingReject: (id) => `admin-pending-reject-${id}`,
  adminPendingRow: (id) => `admin-pending-row-${id}`,
  adminQuoteSelect: (id) => `admin-quote-select-${id}`,
  adminQuoteSelectAll: "admin-quote-select-all",
  adminQuoteBulkDelete: "admin-quote-bulk-delete",

  // Collab
  collabItemStatus: (id) => `collab-item-status-${id}`,
  collabQuotePartnerPdf: (id) => `collab-quote-partner-pdf-${id}`,
  adminCollabApprove: (id) => `admin-collab-approve-${id}`,
  adminCollabReject: (id) => `admin-collab-reject-${id}`,
  adminCollabDelete: (id) => `admin-collab-delete-${id}`,
  adminCollabRow: (id) => `admin-collab-row-${id}`,

  // Collaborator area
  navCollab: "nav-collab",
  collabLoginEmail: "collab-login-email",
  collabLoginPassword: "collab-login-password",
  collabLoginBtn: "collab-login-btn",
  collabRegisterEmail: "collab-register-email",
  collabRegisterPassword: "collab-register-password",
  collabRegisterName: "collab-register-name",
  collabRegisterPhone: "collab-register-phone",
  collabRegisterBtn: "collab-register-btn",
  collabLogoutBtn: "collab-logout-btn",
  collabAddItemBtn: "collab-add-item-btn",
  collabTabItems: "collab-tab-items",
  collabTabQuotes: "collab-tab-quotes",
  adminAddBlockBtn: "admin-add-block-btn",
  adminBlockForm: "admin-block-form",
  adminBlockItem: "admin-block-item",
  adminBlockQty: "admin-block-qty",
  adminBlockStart: "admin-block-start",
  adminBlockEnd: "admin-block-end",
  adminBlockReason: "admin-block-reason",
  adminBlockSave: "admin-block-save-btn",
  adminBlockCard: (id) => `admin-block-card-${id}`,
  adminBlockRemove: (id) => `admin-block-remove-${id}`,
  adminQuoteStatus: (id) => `admin-quote-status-${id}`,
  adminQuoteConfirm: (id) => `admin-quote-confirm-${id}`,
  adminQuoteReject: (id) => `admin-quote-reject-${id}`,
  adminQuoteReopen: (id) => `admin-quote-reopen-${id}`,
  adminQuotePdf: (id) => `admin-quote-pdf-${id}`,
  adminCalPrev: "admin-calendar-prev",
  adminCalNext: "admin-calendar-next",
  adminCalDay: (day) => `admin-calendar-day-${day}`,
  adminTierMinDays: (i) => `admin-tier-mindays-${i}`,
  adminTierPercent: (i) => `admin-tier-percent-${i}`,
  adminTierRemove: (i) => `admin-tier-remove-${i}`,
  adminTierAdd: "admin-tier-add",
  adminTiersSave: "admin-tiers-save",
};
